import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../../components/common/pageLayout';
import Form from '../../components/Leave/ApplyForm';
import constant from '../../constant';
import { toast } from 'react-toastify';
import { v3_add_leave_application, v3_edit_leave_application } from '../../actions/v3/leave';
import { getLoggedInUserGender } from '../../utils';
import { v2_get_available_leave_types, v2_siteLocations } from '../../actions/v2/masterData';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import {v3_designations} from "../../actions/v3/designation";

const Add = (props) => {

    const location = useLocation();
    const { data, page } = location.state || {};
    const [leaveTypes, setLeaveTypes] = useState([]);
    const [siteLocations, setSiteLocations] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchLeaveTypes = async () => {
        const gender = getLoggedInUserGender(); // 'Male' | 'Female' | 'All'
        const res = await v2_get_available_leave_types(gender);
        if (res.status) {
            setLeaveTypes(res.result || []);
        } else {
            toast.error('Failed to load leave types');
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchLeaveTypes();
        v2_siteLocations().then((res) => {
            if (res.status) {
                setSiteLocations(res.result || [])
            }
        })
    }, []);

    useEffect(() => {
            v3_designations(1, 1000).then((res) => {
                if (res.status) {
                    setDesignations(res.result || [])
                }
                else {
                    toast.error(res.error)
                }
            })
        }, [])

    const onSubmit = async (model) => {
        try {
            model.leaveId = JSON.parse(atob(data))['ID']
            const res = await v3_edit_leave_application(model);
            if (res.status) {
                toast.success(res.result.message || 'Leave application modified successfully!');
                props.history.push(constant.Authedcomponent.leaveApplied.url, {
                    page: page // Replace 'yourData' with the data you want to pass
                });
            } else {
                toast.error(res.error || 'Something went wrong!');
            }
        } catch (err) {
            toast.error('Server error while editing leave application.');
            console.error(err);
        }
    };

    return (
        <Layout title="Edit Leave Application">
            {loading ? (
                <div>Loading leave types...</div>
            ) : (
                <Form
                    data={JSON.parse(atob(data))}
                    title="Edit Leave"
                    onSubmit={onSubmit}
                    leaveTypes={leaveTypes}
                    siteLocations={siteLocations}
                    buttonName="Apply"
                    designations={designations.designations || []}
                />
            )}
        </Layout>
    );
};

export default Add;
